"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[594],{

/***/ 4341:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Service_card; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(6734);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(1776);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(7832);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./components/BookNow/BookNow.tsx
var BookNow = __webpack_require__(6562);
// EXTERNAL MODULE: ./components/Cards/Card.tsx
var Card = __webpack_require__(2132);
// EXTERNAL MODULE: ./node_modules/react-icons/md/index.esm.js
var index_esm = __webpack_require__(6631);
// EXTERNAL MODULE: ./node_modules/next-translate/lib/esm/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(8757);
;// CONCATENATED MODULE: ./components/Badges/Virtual.badge.tsx




function VirtualBadge() {
    const { t  } = (0,useTranslation/* default */.Z)("common");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
        className: "inline-flex items-center text-primary-500 text-sm",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* MdOutlineVoiceChat */.I51, {
                className: "h-4 w-4 mr-1"
            }),
            t("sections.services.virtual")
        ]
    });
}
/* harmony default export */ var Virtual_badge = (/*#__PURE__*/(0,react.memo)(VirtualBadge));

// EXTERNAL MODULE: ./hooks/useReadmore.ts + 1 modules
var useReadmore = __webpack_require__(1123);
// EXTERNAL MODULE: ./hooks/useFetch.ts + 1 modules
var useFetch = __webpack_require__(9350);
// EXTERNAL MODULE: ./utils/utils.ts
var utils = __webpack_require__(8728);
;// CONCATENATED MODULE: ./components/Services/Service.card.tsx









const ServiceCard = (param)=>{
    let { id , title , description , hasVirtualBadge , imageUrl , duration , price , unavailableItems  } = param;
    const unavailableItem = (0,react.useMemo)(()=>{
        return unavailableItems === null || unavailableItems === void 0 ? void 0 : unavailableItems.reduce((obj, cur)=>({
                ...obj,
                [cur]: true
            }), {});
    }, [
        unavailableItems
    ]);
    const [truncated, hasLimit] = (0,useReadmore/* default */.Z)(description || "", 320);
    const { data: businessProfile  } = (0,useFetch/* useBusinessProfile */.jB)();
    const widgetSetting = businessProfile === null || businessProfile === void 0 ? void 0 : businessProfile.data;
    const priceFormatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: widgetSetting === null || widgetSetting === void 0 ? void 0 : widgetSetting.currency.name
    });
    const showPrice = price === 0 && "Free" || priceFormatter.format(price);
    const hasDurationOrPrice = !(unavailableItem === null || unavailableItem === void 0 ? void 0 : unavailableItem.duration) || !(unavailableItem === null || unavailableItem === void 0 ? void 0 : unavailableItem.price);
    const hasDurationAndPrice = !(unavailableItem === null || unavailableItem === void 0 ? void 0 : unavailableItem.duration) && !(unavailableItem === null || unavailableItem === void 0 ? void 0 : unavailableItem.price);
    const isImageHidden = unavailableItem === null || unavailableItem === void 0 ? void 0 : unavailableItem.image;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex gap-4 sm:gap-8 items-start flex-col sm:flex-row",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex-auto",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                            className: "font-medium text-lg mb-1",
                            children: title
                        }),
                        (hasVirtualBadge || hasDurationOrPrice) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "inline-flex items-center space-x-2",
                            children: [
                                hasVirtualBadge && /*#__PURE__*/ (0,jsx_runtime.jsx)(Virtual_badge, {}),
                                hasDurationOrPrice && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    className: "bg-primary-50 px-2 py-1 rounded-md text-xs",
                                    children: [
                                        !(unavailableItem === null || unavailableItem === void 0 ? void 0 : unavailableItem.duration) && "".concat(duration / 60, " min"),
                                        hasDurationAndPrice && " | ",
                                        !(unavailableItem === null || unavailableItem === void 0 ? void 0 : unavailableItem.price) && "".concat(showPrice)
                                    ]
                                })
                            ]
                        }),
                        !(unavailableItem === null || unavailableItem === void 0 ? void 0 : unavailableItem.description) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            className: "text-sm mt-2 text-[#46474a] leading-6 break-word pre-line",
                            children: [
                                truncated,
                                hasLimit && " ..."
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "w-full sm:w-auto min-w-[9rem] max-w-none sm:max-w-[9rem] flex-none flex flex-col space-y-3 justify-end sm:pl-4",
                    children: [
                        !isImageHidden && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "relative aspect-[1.6] sm:aspect-[1.18] overflow-hidden",
                            children: (imageUrl === null || imageUrl === void 0 ? void 0 : imageUrl.url) && /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                className: "w-full h-full rounded-lg bg-gray-200 object-cover select-none",
                                src: (imageUrl === null || imageUrl === void 0 ? void 0 : imageUrl.url) || (0,utils/* resolvedPublicPath */.dO)("service-placeholder.svg"),
                                alt: (imageUrl === null || imageUrl === void 0 ? void 0 : imageUrl.alt) || title,
                                width: 300,
                                height: 254,
                                quality: 90,
                                loading: "lazy"
                            }) || /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "absolute inset-0 rounded-lg flex items-center justify-center bg-gray-200 text-gray-500",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                    className: "w-6 h-6",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    fill: "none",
                                    viewBox: "0 0 32 32",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            fill: "currentColor",
                                            d: "m3.002 26.763 1.853.796V14.728l-3.36 8.327a2.897 2.897 0 0 0 1.507 3.708Zm26.966-5.258L23.113 4.497a2.785 2.785 0 0 0-2.507-1.748 2.72 2.72 0 0 0-1.093.213L9.327 7.296a2.84 2.84 0 0 0-1.701 2.558c-.014.39.057.777.207 1.137l6.86 17.007a2.768 2.768 0 0 0 2.53 1.748c.365 0 .727-.073 1.065-.213L28.466 25.2a2.861 2.861 0 0 0 1.507-3.694h-.005Zm-12.723 5.4L10.387 9.91l10.164-4.318h.015l6.846 16.98-10.167 4.332Z"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            fill: "currentColor",
                                            d: "M14.635 12.907a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM8.168 27.746a2.005 2.005 0 0 0 2 2h1.455l-3.455-8.34v6.34Z"
                                        })
                                    ]
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BookNow/* default */.Z, {
                            uniqueIdentifier: widgetSetting === null || widgetSetting === void 0 ? void 0 : widgetSetting.widget.uniqueIdentifier,
                            type: "service",
                            id: id,
                            buttonWide: true
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var Service_card = (/*#__PURE__*/(0,react.memo)(ServiceCard));


/***/ }),

/***/ 6594:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6734);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1776);
/* harmony import */ var lodash_es_chunk__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(3978);
/* harmony import */ var hooks_useFetch__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9350);
/* harmony import */ var components_Services_Service_card__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4341);
/* harmony import */ var components_Loading_Loading__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4737);
/* harmony import */ var types_business_types__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(3345);
/* harmony import */ var hooks_useVirtualized__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1764);








function ServicesList(param) {
    let {} = param;
    const { data: businessProfile  } = (0,hooks_useFetch__WEBPACK_IMPORTED_MODULE_2__/* .useBusinessProfile */ .jB)();
    const widgetSetting = businessProfile === null || businessProfile === void 0 ? void 0 : businessProfile.data;
    const unavailableItems = widgetSetting === null || widgetSetting === void 0 ? void 0 : widgetSetting.widget.settings.service.unavailableItems;
    const { data , error , fetchNextPage , isFetching , isFetchingNextPage , status  } = (0,hooks_useFetch__WEBPACK_IMPORTED_MODULE_2__/* .useServices */ .Su)(widgetSetting === null || widgetSetting === void 0 ? void 0 : widgetSetting.key);
    const services = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(()=>{
        return data === null || data === void 0 ? void 0 : data.pages.flatMap((page)=>page.items);
    }, [
        data
    ]);
    const chunkyData = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(()=>(0,lodash_es_chunk__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(services, 2), [
        services
    ]);
    const lastPage = data === null || data === void 0 ? void 0 : data.pages[data.pageParams.length - 1];
    const hasNextPage = (lastPage === null || lastPage === void 0 ? void 0 : lastPage.hasNext) || false;
    const { parentRef , rowVirtualizer , items , totalSize  } = (0,hooks_useVirtualized__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        fetchNextPage,
        isFetchingNextPage,
        hasNextPage,
        length: chunkyData.length
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            status === "loading" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Loading_Loading__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {}) : status === "error" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                children: [
                    "Error: ",
                    error.message
                ]
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                ref: parentRef,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "relative w-full",
                    style: {
                        height: totalSize
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "absolute top-0 left-0 w-full",
                        style: {
                            transform: "translateY(".concat(items[0].start - rowVirtualizer.options.scrollMargin, "px)")
                        },
                        children: items.map((virtualRow)=>{
                            const isLoaderRow = virtualRow.index > chunkyData.length - 1;
                            const row = chunkyData[virtualRow.index];
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                "data-index": virtualRow.index,
                                ref: rowVirtualizer.measureElement,
                                className: "grid grid-cols-1 lg:grid-cols-2 gap-4 pb-4",
                                children: isLoaderRow ? hasNextPage ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Loading_Loading__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {}) : "Nothing more to load" : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                    children: row.map((item)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Services_Service_card__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                            id: item.id,
                                            hasVirtualBadge: item.appointmentType === types_business_types__WEBPACK_IMPORTED_MODULE_5__/* .AppointmentType.Virtual */ .Vn.Virtual,
                                            title: item.name,
                                            description: item.description,
                                            imageUrl: item.image,
                                            duration: item.duration,
                                            price: item.price,
                                            unavailableItems: unavailableItems
                                        }, item.id))
                                })
                            }, virtualRow.key);
                        })
                    })
                })
            }),
            isFetching && !isFetchingNextPage ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Loading_Loading__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {}) : null
        ]
    });
}
/* harmony default export */ __webpack_exports__["default"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.memo)(ServicesList));


/***/ })

}]);